import React, { useEffect, useState, useCallback } from "react";
import { styled } from "@linaria/react";
import Icon from "@components/_Revamp/Icon";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription";
import {Checkbox} from "./../Checkbox";
import ToolTipBottom from "@assets/icon/tool-tip-bottom.svg";
import infoBlack from "@assets/icon/info-gray-solid.svg";
import Accordion from "../Accordion";
import MyInfoForm from "@pages/ShieldStarter/Steps/StartApplication/MyInfoForm";
import { updateWhomToBuy } from "@redux/slices/SHIELD_STARTER/step1Slice";
import { updateSelectedChildInfo, updatePersonalChildInfo, InfoProps, 
  updatePersonalInfo, updateChildItem, updateToDefaultStateStep3 } from "@redux/slices/SHIELD_STARTER/step3Slice";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import Link from "@components/_Revamp/Link";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import ErrorModal from "../Modals/ErrorModal";
import { updateHeightAndWeight, updateUWQCompleted } from "@redux/slices/SHIELD_STARTER/step4Slice";
import { Tooltip } from "../Tooltip";
import useReduxReset from "@pages/ShieldStarter/Helpers/useReduxReset";
import Button from "../Button";
import { css } from "@linaria/core";
import { SCREEN_SIZE } from "@static/screen-size";


const Wrap = styled.div`
  max-width: 864px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 50px auto auto;
  // padding: 36px;
  flex-direction: column;
  flex-wrap: wrap;
`;

interface ListTitleProps {
  bcolor?: string;
}

const ListTitle = styled.h1<ListTitleProps>`
  font-weight: 600;
  font-size: 16px;
  color: #434343;
  padding-left: 16px;
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 16px;

  &:before {
    background-color: ${(props) => (props.bcolor ? props.bcolor : "#C50000")};
    border-radius: 4px;
    content: "";
    width: 6px;
    height: 100%;
    position: absolute;
    left: 0;
  }
`;

const List = styled.div`
  font-size: 18px;
  background-color: #fff;
  padding: 24px;
  border-radius: 24px;
  color: #434343;
  letter-spacing: 0.04em;
  display: flex;
  column-gap: 20px;
  margin-top: 24px;
  width: calc(100% - 48px);
  align-items: center;
  font-weight: 600;
  cursor: pointer;
`;

const ListEmpty = styled.div`
  font-size: 20px;
  padding: 24px;
  border-radius: 24px;
  color: #434343;
  letter-spacing: 0.04em;
  margin-top: 24px;
  width: calc(100% - 48px);
  align-items: center;
  font-weight: 600;
  cursor: pointer;
  border: 2px dashed #883e89;
  text-align: center;
  color: #883e89;
`;

interface TextProps {
  color?: string;
  fSize?: string;
  weight?: number;
  mg?: string;
}

const Text = styled.div<TextProps>`
  color: ${(props) => (props.color ? props.color : "#434343")};
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  font-size: ${(props) => (props.fSize ? props.fSize : "12px")};
  margin: ${(props) => (props.mg ? props.mg : "0")};
  letter-spacing: 0.04em;
`;

const RedioWrap = styled.span`
  position: absolute;
  top: 54px;
  left: 24px;
  right:unset;
  z-index: 10;
  width:100%;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width:unset;
    left: unset;
    right: 24px;
    top: 16px;
  }
`;

const ListWarp = styled.span`
  position: relative;
  width: 100%;
  margin-top: 24px;
`;

const MyInfoWrap = styled.div`
  margin: 0 64px;
  padding: 24px 0;
  border-top: 1px solid #eee;
`;

const EmptyWrap = styled.span`
  margin-top: 24px;
  background: #FFFFFF;
  border-radius: 16px;
  width: 100%;
`;

const EmptyName = styled.span`
  padding: 24px;
  font-weight: 600;
  font-size: 18px;
  display: flex;
`;

function ListWithTitle(props: any) {
  const history = useHistory();
  const {
    title,
    toolTip,
    bcolor,
    items,
    isCheckable,
    restartJourney,
    infoType,
    openChildItem,
    itemType,
  } = props;
  const dispatch = useAvivaDispatch();
  const selectedChildInfo: any = useAvivaSelector(
    (state) => state.shieldStarterStep3.selectedChildInfo
  );
  const [radioChange, setRadioChange] = useState<string>(
    selectedChildInfo ? selectedChildInfo.fullName : ""
  );
  const [noChildClick, setNoChildClick] = useState(false);
  const clearStore = useReduxReset();

  function selectChild(child: any) {
    setRadioChange(child?.fullName);
    dispatch(updateSelectedChildInfo(child));
    dispatch(updateUWQCompleted(false));
    const heightAndWeight = {
      height: 0,
      weight: 0,
    };
    dispatch(updateHeightAndWeight(heightAndWeight))
  }

  function resetFlow() {
    clearStore()
    history.replace(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
  }

  const updateInfoFn = (childInfo: InfoProps, index: number) => {
    if (itemType && childInfo) {
      dispatch(updateChildItem({item:childInfo, index: index, itemType: itemType}));
      const hasInfo = !isEmpty(selectedChildInfo) && selectedChildInfo.fullName === childInfo.fullName;
      if (hasInfo) {
        dispatch(updateSelectedChildInfo(childInfo));
      }
    }
  }
  
  return (
    <>
      <Wrap>
        <ListTitle bcolor={bcolor || (items && items[0]?.colorFlag)}>
          <span>{title}</span>
          {toolTip && (
            <Tooltip title={title} isIcon={true}>
              <p>{toolTip}</p>
            </Tooltip>
          )}
        </ListTitle>
        {items ? (
          items.map((item: any, i: number) =>
            item?.fullName ? (
              <ListWarp key={i}>
                <RedioWrap>
                  {isCheckable && (
                    //Backup for the previoud Radio button implementation
                    // <Checkbox
                    //   type="radio"
                    //   checked={item?.fullName === radioChange}
                    //   name="availablePurchase"
                    //   newRedio={true}
                    //   onChange={() => {
                    //     let target = {
                    //       target: {
                    //         name: "availablePurchase",
                    //         value: item?.fullName,
                    //       },
                    //     };
                    //     selectChild(item);
                    //   }}
                    // />
                    <Button
                      variant={
                        item?.fullName === radioChange ? "default" : "secondary"
                      }
                      className={childSelectButton}
                      onClick={() => {
                        selectChild(item);
                      }}
                      label={
                        item?.fullName === radioChange ? "Selected" : "Select"
                      }
                    />
                  )}
                  {restartJourney && (
                    //Backup Restart Journey flow
                    // <Link
                    //   onClick={resetFlow}
                    //   text="Restart Journey"
                    //   underline={false}
                    //   fontSize={14}
                    //   fontWeight="600"
                    //   variant="button"
                    // />
                    <Button
                      variant="secondary"
                      className={`${childSelectButton} ${restartButton}`}
                      onClick={resetFlow}
                      label="Restart application"
                    />
                  )}
                </RedioWrap>
                <Accordion
                  className={
                    (isCheckable || restartJourney) && accordinChildInfo
                  }
                  isExpanded={openChildItem === item?.fullName + item?.nric}
                  title={item?.fullName || item?.nric}
                  item={item}
                  id={item?.fullName + item?.nric}
                >
                  <MyInfoWrap>
                    <MyInfoForm
                      personalInfo={item}
                      infoType={infoType}
                      updateInfoFn={(info: InfoProps) =>
                        updateInfoFn({ ...item, ...info }, i)
                      }
                    />
                  </MyInfoWrap>
                </Accordion>
              </ListWarp>
            ) : (
              <EmptyWrap key={i}>
                <EmptyName>{item?.nric}</EmptyName>
              </EmptyWrap>
            )
          )
        ) : (
          <ListEmpty onClick={() => setNoChildClick(true)}>
            Need help? Reach us here <Icon name={"chevron-right-purple"} />
          </ListEmpty>
        )}
      </Wrap>
      {noChildClick && (
        <ErrorModal
          error={
            "We are unable to locate your child(ren)’s details. \n You may wish to contact our Financial Adviser Representative for assistance."
          }
          title="Need help? Contact us"
          onCloseFn={() => setNoChildClick(false)}
        />
      )}
    </>
  );
}
export default ListWithTitle;

const accordinChildInfo = css`
  .headerForChildInfo {
    padding-bottom: 82px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .headerForChildInfo {
      padding-bottom: 24px;
    }
  }
`;

const childSelectButton = css`
  height: 42px;
  align-self: stretch;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  padding: 12.8px 40px;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.56px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 180px;
    margin-top: unset;
  }
`;

const restartButton = css`
  height: 42px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: unset;
  }
`;